import { TaskStatusType } from '@kc-console/context';
import { t } from '@kc-console/core';

import type { BadgeColor } from '@kc-console/common-ui';
import type { TaskTabKey } from '@kc-console/context';

/**
 * 태스크 매니저 탭 정의(전체/진행중/성공/실패).
 * @description
 * - 라벨 옆 카운트는 `Badge`(circular/tint)로 표시하며, 탭별 색은 `countColor`를 따른다.
 *   진행중=blue, 성공=green, 실패=red. 'all' 탭은 카운트를 표시하지 않으므로 `countColor`가 없다.
 */
export const getTaskTabs = (): {
  label: string;
  value: TaskTabKey;
  countColor?: BadgeColor;
}[] => [
  { value: 'all', label: t('common:common.label.all') },
  {
    value: 'in_progress',
    label: t('layout:task_manager.status.in_progress.label'),
    countColor: 'blue',
  },
  { value: 'success', label: t('layout:task_manager.status.success.label'), countColor: 'green' },
  { value: 'failed', label: t('layout:task_manager.status.failed.label'), countColor: 'red' },
];

/** statusType → 진행바 색 톤. success/failed/warning만 바 색을 오버라이드(in_progress는 컴포넌트 기본값). */
export const getProgressTone = (
  statusType: string,
): 'default' | 'success' | 'failed' | 'warning' => {
  if (statusType === TaskStatusType.SUCCESS) return 'success';
  if (statusType === TaskStatusType.FAILED) return 'failed';
  if (statusType === TaskStatusType.WARNING) return 'warning';
  return 'default';
};
